import { createSlice } from '@reduxjs/toolkit';

import { Employer } from '@backrs_ui/common-ui';

import { RootState } from '../store';

type EmployerState = Readonly<{
  employer?: Employer;
  loading?: boolean;
  error?: string;
}>;

const initialState: EmployerState = {
  employer: undefined,
  loading: false,
  error: undefined,
};

export const employerSlice = createSlice({
  name: 'employerState',
  initialState,
  reducers: {
    resetEmployer: (state) => {
      state.employer = undefined;
      state.loading = false;
      state.error = undefined;
    },
  },
});

export const selectEmployer = (state: RootState) => state.employer.employer;

export const { resetEmployer } = employerSlice.actions;
